import React from 'react';
import Trend from 'react-trend';
import { arrayOf, number } from 'prop-types';

export default function Trendline({ trendData, width, height }) {
  return (
    <Trend
      autoDraw
      autoDrawDuration={600}
      autoDrawEasing="ease-out"
      data={trendData}
      stroke={'#00f'}
      strokeWidth={1.5}
      width={width}
      height={height}
      padding={2}
      strokeLinecap={'square'}
    />
  );
}

Trendline.propTypes = {
  trendData: arrayOf(number),
  width: number.isRequired,
  height: number.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Trendline/index.js